import { render, staticRenderFns } from "./c-placeholder-loader.vue?vue&type=template&id=17b8cd08&functional=true&"
import script from "./c-placeholder-loader.vue?vue&type=script&lang=js&"
export * from "./c-placeholder-loader.vue?vue&type=script&lang=js&"
import style0 from "./c-placeholder-loader.vue?vue&type=style&index=0&id=17b8cd08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports